export default __webpack_public_path__ + "static/media/inversion_demo_UK_optim.5babee29.gif";